import React , {Suspense ,  useState , useCallback , useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import LinearProgress from '@mui/material/LinearProgress';
import   'scss/components/page-components/Layout/CssReset.scss';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import   'scss/components/page-components/AppLayout.scss';
import useLoginToken  from 'js/Services/Auth/ReactHooks/useLoginToken.js'; 
import 'enableEs5Includes';
import useListenForUnreadChats from 'js/Services/Chats/hooks/useListenForUnreadChats.js';
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation
  } from "react-router-dom";
import   useAppReducer  from 'js/Reducers/AppReducer.js';
import AppContext from  'js/Contexts/App.js';
import useAuth from 'js/Services/Auth/ReactHooks/useAuth.js';
// import useGoogleOptimize from 'js/Services/GoogleOptimize.js';
import PageCouldNotBeLoaded from 'js/Pages/PageCouldNotBeLoaded.js';
// Theme imports
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import useAppTheme from 'js/theme/useAppTheme';

import { routeUrlToPageLoader , routePageModuleStringToPageLoader , useRouter } from 'js/Router.js';

 import AppInitPage from 'js/Pages/AppInitPage.js';

import useUserNotifications from  'js/Services/UserNotifications/useUserNotifications.js';

import fetchTranslationGroup from 'js/Services/Translations/fetchTranslationGroup.js';
import useAccountSubscriptions from 'js/Services/AccountSubscriptions/ReactHooks/useAccountSubscriptions.js';

const setAppBadge = ( badgeNnum )=>{
    if( navigator.setAppBadge ){
        navigator.setAppBadge(badgeNnum);
      }  else if( navigator.setExperimentalAppBadge ){
        navigator.setExperimentalAppBadge(badgeNnum);
      } else if( window.ExperimentalBadge  ){
        window.ExperimentalBadge.set(badgeNnum);
      }
}



const App = (props) => {
    // Use the theme hook to get theme
    const { theme } = useAppTheme();

    const location = useLocation();
    const locationNow = location;
    let startTime = new Date();
    const inFetchLayoutTranslations = useRef(false);
    const [currentFetchedLayoutLanguage, setCurrentFetchedLayoutLanguage] = useState(null);

    const [layoutTranslations , setLayoutTranslations ] = useState(null);
    const [layoutTranslationsInitialized , setLayoutTranslationsInitialized ] = useState(null);


    const [languageInitialized , setLanguageInitialized] = useState(false);
    const appData = props.appData;
    const [ windowSize , setWindowSize ] = useState( window.innerWidth + '-' + window.innerHeight );
    
    const [ mainLayoutState , _setMainLayoutState ] = useState(() => {
        let foldOutOpen = null;
        if (foldOutOpen == null && window.sessionStorage) {
            const storageVal = window.sessionStorage.getItem('mainLayoutState_foldMenuOutOpen');
            if (storageVal == 'open' || storageVal == 'closed') {
                foldOutOpen = storageVal == 'open' ? true : false;
            }
        }

        if (foldOutOpen == null) {
            foldOutOpen = window.innerWidth > 767;
        }

        return {
            'foldOutOpen': foldOutOpen,
            'userDropwDownOpen': false
        };
    });

    const setMainLayoutState = (state) => {
        if( state.foldOutOpen != mainLayoutState.foldOutOpen ){
            window.sessionStorage.setItem('mainLayoutState_foldMenuOutOpen', (state.foldOutOpen ? 'open' : 'closed'));
        }
        _setMainLayoutState(state);
    };
    const googleOptimizeExperiments = {};//useGoogleOptimize();

    const translateOnlineStatus = () => {
        const status = window.navigator.onLine ;
        return ( status === 'off' || status == false ? false : true);
    };
    const [ browserOnlineStatus , setBrowserOnlineStatus ] = useState(translateOnlineStatus() );


    const handleBrowserOnlineStatus = useCallback( () => {
        setBrowserOnlineStatus(translateOnlineStatus());
    });
    const handleWindowResize = useCallback( () => {
        setWindowSize(window.innerWidth + '-' + window.innerHeight);
    });
    const handleWindowResizeRef = useRef();
    handleWindowResizeRef.current = handleWindowResize;


    const handleBrowserOnlineStatusRef = useRef();
    handleBrowserOnlineStatusRef.current = handleBrowserOnlineStatus;

   

    const resizeHandlerMounted = useRef( false );
    useEffect(() => {
        if( !resizeHandlerMounted.current){
            window.addEventListener('resize',  handleWindowResizeRef.current  ,  {  passive: true  });
            window.addEventListener('online',   handleBrowserOnlineStatusRef.current);
            window.addEventListener('offline',   handleBrowserOnlineStatusRef.current);

            resizeHandlerMounted.current = true;
        }

        return () => {
            window.removeEventListener('online',  handleBrowserOnlineStatusRef.current  );
            window.removeEventListener('offline', handleBrowserOnlineStatusRef.current  );
        }
    } , []);

    const GApageviewInitialized = useRef(false);
    useEffect( ()=>{
        if( GApageviewInitialized.current ){
            gtag('event',  'page_view');
        }
        GApageviewInitialized.current  = true;
    } ,  [ document.location.pathname ] );


    const [ autServiceInitialized , , authService]  = useAuth( );
    const accountSubscriptionService = useAccountSubscriptions(authService);
    const appReducer = useAppReducer(props.appData , authService );
    const logintTokenAttempt = useLoginToken(authService);

    const appLanguage = appReducer.getCurrentLanguage();

    const  [  userNotificationsSummary , numOpenNotifications ]   = useUserNotifications( authService );
    const appInitialiazed = ( autServiceInitialized || languageInitialized );

    const [ numUnreadChatMessages , chatSocketConnected ] = useListenForUnreadChats(  authService.getCurrentIdentity()?.user , authService );
   

    useEffect( ()=> {
        if( autServiceInitialized ) {
            appReducer.recalculateCurrentLanguage() ;
            setLanguageInitialized(true);
        }
      } , [ autServiceInitialized ] );


    useEffect( ()=>{
      if(appLanguage){
        if( !inFetchLayoutTranslations.current && currentFetchedLayoutLanguage != appLanguage ){
           ( async ()=>{
            inFetchLayoutTranslations.current = true;
              try{
                  const translations = await fetchTranslationGroup('Website_Backoffice_Layout' , appLanguage );;
                  setLayoutTranslations(translations);
                setCurrentFetchedLayoutLanguage(appLanguage);
              } catch(e){
                  setLayoutTranslations([]);
              }

              inFetchLayoutTranslations.current = false;

              setLayoutTranslationsInitialized(true);
          })();
        }

      }
    },[ appLanguage ]);

    const [ currentPage , prevPage , shownPage , showLoader , shownModule , routerReducer ] = useRouter( locationNow ,  props.appData , appReducer );
    setAppBadge(numOpenNotifications + numUnreadChatMessages);
    if( !appInitialiazed || !layoutTranslationsInitialized ) {
        return <AppInitPage />;
    }

    if( logintTokenAttempt ){
        return logintTokenAttempt;
    }
    // Check if user is logged in
    const isLoggedIn = Boolean(authService.getCurrentIdentity());
    
    // Create an adjusted layout state - hide sidebar if not logged in
    const adjustedMainLayoutState = {
        ...mainLayoutState,
        foldOutOpen: isLoggedIn ? mainLayoutState.foldOutOpen : false
    };
    
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppContext.Provider value={{ 
                numUnreadChatMessages, 
                layoutTranslations, 
                googleOptimizeExperiments, 
                mainLayoutState: adjustedMainLayoutState, 
                setMainLayoutState, 
                userNotificationsSummary, 
                location, 
                appReducer, 
                authService, 
                appLanguage,
                AccountSubscriptionService: accountSubscriptionService,
                // Add theme to the context
                theme
            }}>
                {showLoader && <div className="App_loadingPopover"><LinearProgress className="loader" /></div>}
                {shownPage}
                {!window.navigator.onLine && 
                    <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center'}} open={true} onClose={()=>{}}>
                        <Alert severity="warning">Offline</Alert>
                    </Snackbar>
                }
            </AppContext.Provider>
        </ThemeProvider>
    );

    // Check if user is logged in (repeated for second return statement)
    const isLoggedInForRoutes = Boolean(authService.getCurrentIdentity());
    
    // Create an adjusted layout state for routes
    const adjustedLayoutStateForRoutes = {
        ...mainLayoutState,
        foldOutOpen: isLoggedInForRoutes ? mainLayoutState.foldOutOpen : false
    };
    
    return (
        <AppContext.Provider value={{ googleOptimizeExperiments, mainLayoutState: adjustedLayoutStateForRoutes, setMainLayoutState, userNotificationsSummary, location, appReducer, authService, appLanguage }}  >
         <Routes>
            <Route path="/" >
                    <Route index element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <OrdersPage />
                        </Suspense>} />


                    <Route path="forgot-password"
                         element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <ForgotPasswordPage />
                        </Suspense>}
                    />

                    <Route path="orders"  >
                        <Route index element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <OrdersPage />
                        </Suspense>} />
                        <Route path=":orderId" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <OrderPage />
                        </Suspense>} />
                    </Route>

                    <Route path="login"
                         element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <LoginPage />
                        </Suspense>}
                    />
                    <Route path="register"
                         element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserRegisterPage />
                        </Suspense>}
                    />

                    <Route path="accountmanager-invite/:inviteToken"
                         element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <AccountManagerInviteRedeemPage />
                        </Suspense>}
                    />



                    <Route path="accounts" >
                        <Route index element={  <div>Account Selector</div>   }/>

                        <Route path=":accountId" >
                            <Route
                                index
                                element={
                                    <Suspense fallback={<LoadingLoggedInPage />}>
                                        <AccountDashboardPage />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="create-order"
                                element={
                                    <Suspense fallback={<LoadingLoggedInPage />}>
                                        <AccountCreateOrderPage />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="managers"
                                element={
                                    <Suspense fallback={<LoadingLoggedInPage />}>
                                        <AccountManagersPage />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="add-manager"
                                element={
                                    <Suspense fallback={<LoadingLoggedInPage />}>
                                        <AccountManagersAddManagerPage />
                                    </Suspense>
                                }
                            />


                            <Route
                                path="settings"
                                element={
                                    <Suspense fallback={<LoadingLoggedInPage />}>
                                        <AccountSettingsPage />
                                    </Suspense>
                                }
                            />

                            <Route
                                path="orders"
                            >
                                    <Route
                                        index
                                        element={
                                            <Suspense fallback={<LoadingLoggedInPage />}>
                                                <AccountOrdersPage />
                                            </Suspense>
                                        }
                                    />

                                    <Route
                                        path=":orderId"
                                        element={
                                            <Suspense fallback={<LoadingLoggedInPage />}>
                                                <AccountOrdersPage />
                                            </Suspense>
                                        }
                                    />



                            </Route>
                        </Route>
                    </Route>

                    <Route path="me" >
                        <Route index element={  <Suspense fallback={<LoadingLoggedInPage />}  ><UserDashboardPage /></Suspense>  }/>

                        <Route path="change-password" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <ChangePasswordPage />
                        </Suspense>} />

                        <Route path="change-email" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <ChangeEmailPage />
                        </Suspense>} />
                        <Route path="dashboard" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDashboardPage />
                        </Suspense>} />
                        <Route path="accounts" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDetailsPage />
                        </Suspense>} />
                        <Route path="security" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDetailsPage />
                        </Suspense>} />
                        <Route path="settings" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDetailsPage />
                        </Suspense>} />
                        <Route path="general" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDetailsPage />
                        </Suspense>} />
                        <Route path="orders" element={ <Suspense fallback={<LoadingLoggedInPage />}>
                            <UserDetailsPage />
                        </Suspense>} />

                    </Route>

                    <Route path="change-email-request " >
                        <Route path=":hash" element={
                            <Suspense fallback={<LoadingLoggedInPage />}>
                                <ChangeEmailRequestPage />
                            </Suspense>}   />
                    </Route>


                    <Route
                        path="*"
                        element={
                            <Suspense fallback={<LoadingLoggedInPage />}>
                                <NotFound />
                            </Suspense>
                        }
                    />

            </Route>


        </Routes>

    </AppContext.Provider>
    );
};

import { createRoot } from 'react-dom/client';
import { SnackbarProvider } from 'notistack';


const container = document.getElementById('appHolder');
const root = createRoot(container);
root.render(
    <SnackbarProvider maxSnack={3} autoHideDuration={3500} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <BrowserRouter>
            <App appData={window.appData} />
        </BrowserRouter>
    </SnackbarProvider>
);

export default App;
